// extracted by mini-css-extract-plugin
export default {"ManagerSidePanel":"styles_ManagerSidePanel__rBJSg","row":"styles_row__FhOoz","col":"styles_col__hSaqY"};